// Loader.jsx
import { useState, useEffect, useRef } from "react";
import { LogoName1, LogoGif } from "../assets";
import styles from "../style";

const Loader = ({ onComplete }) => {
  const [isLoading, setIsLoading] = useState(true);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    
    // Minimum display time for smooth transition
    const minLoadTime = 2100;
    
    const timer = setTimeout(() => {
      if (mountedRef.current) {
        setIsLoading(false);
        setTimeout(() => {
          if (mountedRef.current) {
            onComplete?.();
          }
        }, 100); // Small delay for fade out
      }
    }, minLoadTime);

    return () => {
      mountedRef.current = false;
      clearTimeout(timer);
    };
  }, [onComplete]);

  return (
    <div className={`${styles.flexCenter} bg-black justify-center w-full h-screen flex flex-col gap-4 transition-opacity duration-500 ${isLoading ? 'opacity-100' : 'opacity-0'}`}>
      <img
        src={LogoGif}
        alt="Loader"
        className="w-[150px] h-[150px] object-contain"
      />
      <img
        src={LogoName1}
        alt="logo"
        className="w-[120px] h-[80px] object-contain"
      />
    </div>
  );
};

export default Loader;
/**
 *    <p className="text-tertiary">
        {progress.toFixed(2)}
      </p>
 */